/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description React Hook useWindowSize
 */
// TODO
import { useEffect, useState } from 'react';
import { MINIMUM_DESKTOP_VIEWPORT_WIDTH } from 'app-constants/index';

/**
 * interface for hookvalues
 */
interface IWindowSize {
	windowWidth: number;
	windowHeight: number;
	isDesktop: boolean;
}

/**
 * useWindowSize
 * @returns {IWindowSize} useWindowSize
 */
const useWindowSize = (): IWindowSize => {
	const [size, setSize] = useState({ windowWidth: globalThis.innerWidth, windowHeight: globalThis.innerHeight });

	/**
	 * handle window resize
	 */
	const handleResize = () => setSize({ windowWidth: globalThis.innerWidth, windowHeight: globalThis.innerHeight });

	useEffect(() => {
		handleResize();
		// window resize listener
		globalThis.addEventListener('resize', handleResize);
		return () => globalThis.removeEventListener('resize', handleResize);
	}, []);

	/**
	 * its desktop if window width is  greater than min desktop width
	 */
	const isDesktop = size.windowWidth >= MINIMUM_DESKTOP_VIEWPORT_WIDTH;

	return { ...size, isDesktop };
};

export default useWindowSize;
